import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const KeyIcon = ({
  className,
  ...props
}: {
  className?: string;
} & SvgIconProps) => (
  <SvgIcon
    className={className}
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    {...props}
  >
    <path
      d="M2.58185 17.4135C2.20675 17.7885 1.99596 18.2972 1.99585 18.8275V20.9995C1.99585 21.2648 2.10121 21.5191 2.28874 21.7067C2.47628 21.8942 2.73063 21.9995 2.99585 21.9995H5.99585C6.26107 21.9995 6.51542 21.8942 6.70296 21.7067C6.89049 21.5191 6.99585 21.2648 6.99585 20.9995V19.9995C6.99585 19.7343 7.10121 19.48 7.28874 19.2924C7.47628 19.1049 7.73063 18.9995 7.99585 18.9995H8.99585C9.26107 18.9995 9.51542 18.8942 9.70296 18.7067C9.89049 18.5191 9.99585 18.2648 9.99585 17.9995V16.9995C9.99585 16.7343 10.1012 16.48 10.2887 16.2924C10.4763 16.1049 10.7306 15.9995 10.9958 15.9995H11.1678C11.6982 15.9994 12.2069 15.7886 12.5819 15.4135L13.3958 14.5996C14.7857 15.0837 16.2987 15.0818 17.6873 14.5943C19.076 14.1068 20.2581 13.1624 21.0402 11.9157C21.8224 10.669 22.1583 9.19372 21.993 7.73129C21.8277 6.26885 21.171 4.9058 20.1303 3.86512C19.0896 2.82444 17.7265 2.16773 16.2641 2.00244C14.8017 1.83714 13.3264 2.17305 12.0797 2.95519C10.833 3.73734 9.88864 4.91942 9.4011 6.30807C8.91356 7.69672 8.9117 9.20971 9.39585 10.5996L2.58185 17.4135Z"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16.5001 8.00032C16.7763 8.00032 17.0001 7.77646 17.0001 7.50032C17.0001 7.22418 16.7763 7.00032 16.5001 7.00032C16.224 7.00032 16.0001 7.22418 16.0001 7.50032C16.0001 7.77646 16.224 8.00032 16.5001 8.00032Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
